import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { BREAKPOINTS, WindowSize, WindowSizeChangeEvent } from 'common/window-size/window-size';
import { WindowService } from 'shared/services/window/window.service';
import { debounce } from 'lodash';

@Injectable()
export class WindowSizeService {
  private _resizeSubject = new ReplaySubject<WindowSizeChangeEvent>(1);
  private _current: WindowSize;

  constructor(windowService: WindowService) {
    this.onResize(windowService.innerWidth);
  }

  public get onResize$(): Observable<WindowSizeChangeEvent> {
    return this._resizeSubject.asObservable();
  }

  public get currentSize(): WindowSize {
    return this._current;
  }

  public onResize(windowSize: number): void {
    const size = this._getWindowSize(windowSize);

    if (size !== this._current) {
      this._emitSizeChange(size);
    }
  }

  private _getWindowSize(actualSize: number): WindowSize {
    if (actualSize < BREAKPOINTS[WindowSize.SMALL]) {
      return WindowSize.SMALL;
    }

    if (actualSize < BREAKPOINTS[WindowSize.MEDIUM]) {
      return WindowSize.MEDIUM;
    }

    return WindowSize.LARGE;
  }

  private _emitSizeChange = debounce((newSize: WindowSize) => {
    this._resizeSubject.next({
      previous: this._current,
      current: newSize
    });
    this._current = newSize;
  }, 250, { leading: true, trailing: true });
}
